import axiosUtils from "@/http/axiosUtils";

// const baseUrl = "http://localhost:8080/innerEyes/api"
// const baseUrl = "http://8.138.158.154:8080/innerEyes/api"

const baseUrl = "https://xpanda.work/innerEyes/api"

//登陆
const logIn = (userName, passWord, callback) => {
    axiosUtils.post(baseUrl + "/user/login", {
        "userName": userName, "passWord": passWord
    }, callback)
}

//分页应用列表获取
const pageAppList = (data, callback) => {
    axiosUtils.post(baseUrl + "/app/pageAppList", data, callback)
}

//全部应用列表
const appList = (userId, accessToken, callback) => {
    axiosUtils.post(baseUrl + "/app/appList", {
        "id": userId, "accessToken": accessToken
    }, callback)
}

//新增应用
const creatApp = (userId, accessToken, appData, callback) => {
    appData.userId = userId;
    appData.accessToken = accessToken;
    axiosUtils.post(baseUrl + "/app/creat", appData, callback)
}

//更新应用信息
const update = (userId, accessToken, appData, callback) => {
    appData.userId = userId;
    appData.accessToken = accessToken;
    axiosUtils.post(baseUrl + "/app/update", appData, callback)
}

//删除应用
const deleteApp = (userId, accessToken, appData, callback) => {
    appData.userId = userId;
    appData.accessToken = accessToken;
    axiosUtils.post(baseUrl + "/app/delete", appData, callback)
}

//根据设备ID获取设备
const getDeviceById = (data, callback) => {
    axiosUtils.post(baseUrl + "/device/getDeviceById", data, callback)
}

//分页设备列表
const devicePageList = (userId, accessToken, device, callback) => {
    device.userId = userId;
    device.accessToken = accessToken;
    axiosUtils.post(baseUrl + "/device/devicePageList", device, callback)
}

//删除设备
const deleteDevice = (userId, accessToken, device, callback) => {
    device.userId = userId;
    device.accessToken = accessToken;
    axiosUtils.post(baseUrl + "/device/delete", device, callback)
}

//分页消息列表
const messagePageList = (data, callback) => {
    return axiosUtils.post(baseUrl + "/message/pageList", data, callback)
}

//推送消息
const pushMessage = (data, callback) => {
    return axiosUtils.post(baseUrl + "/message/push", data, callback)
}

//日志文件列表
const fileListForSeq = (data, callback) => {
    return axiosUtils.post(baseUrl + "/files/fileList", data, callback)
}

//获取在线日志
const listOnLineLog = (data, callback) => {
    return axiosUtils.post(baseUrl + "/onlineLog/listOnLineLog", data, callback)
}

//历史在线日志查询
const historyOnLineLog = (data, callback) => {
    return axiosUtils.post(baseUrl + "/onlineLog/historyOnLineLog", data, callback)
}

//获取在线日志开关状态
const getSwitchOnlineLogStatus = (data, callback) => {
    return axiosUtils.post(baseUrl + "/message/getSwitchOnlineLogStatus", data, callback)
}

//设置在线日志开关状态
const setSwitchOnlineLog = (data, callback) => {
    return axiosUtils.post(baseUrl + "/message/setSwitchOnlineLog", data, callback)
}

//设置关键日志无限制上传开关状态
const setCriticalLogSwitch = (data, callback) => {
    return axiosUtils.post(baseUrl + "/app/setCriticalLogSwitch", data, callback)
}

//子账户列表
const getChildUserList = (data, callback) => {
    return axiosUtils.post(baseUrl + "/user/getChildUserList", data, callback)
}

//删除账户
const deleteUser = (data, callback) => {
    return axiosUtils.post(baseUrl + "/user/deleteUser", data, callback)
}

//新增子账户
const addChildUser = (data, callback) => {
    return axiosUtils.post(baseUrl + "/user/addChildUser", data, callback)
}

//更新子账户信息
const updateChildUser = (data, callback) => {
    return axiosUtils.post(baseUrl + "/user/updateChildUser", data, callback)
}
//编辑本账户信息
const updateUser = (data, callback) => {
    return axiosUtils.post(baseUrl + "/user/updateUser", data, callback)
}

//修改密码
const editPassword = (data, callback) => {
    return axiosUtils.post(baseUrl + "/user/editPassword", data, callback)
}

//设备统计
const getDeviceStatistics = (data, callback) => {
    return axiosUtils.post(baseUrl + "/statistics/getDeviceStatistics", data, callback)
}

//APP版本统计
const getVersionStatistics = (data, callback) => {
    return axiosUtils.post(baseUrl + "/statistics/getVersionStatistics", data, callback)
}

//系统版本统计
const getSystemVersionStatistics = (data, callback) => {
    return axiosUtils.post(baseUrl + "/statistics/getSystemVersionStatistics", data, callback)
}

export default {
    logIn,
    pageAppList,
    appList,
    creatApp,
    update,
    deleteApp,
    getDeviceById,
    devicePageList,
    deleteDevice,
    messagePageList,
    fileListForSeq,
    pushMessage,
    listOnLineLog,
    getSwitchOnlineLogStatus,
    setSwitchOnlineLog,
    setCriticalLogSwitch,
    historyOnLineLog,
    getChildUserList,
    deleteUser,
    addChildUser,
    updateChildUser,
    updateUser,
    editPassword,
    getDeviceStatistics,
    getVersionStatistics,
    getSystemVersionStatistics
}